import { render } from "./Footer.vue?vue&type=template&id=205e4b9c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=205e4b9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-205e4b9c"

export default script